import type { RoleCard, Team } from "../protocol";
import { RoleIcon } from "./RoleIcon";

const TYPE_LABEL: Record<RoleCard["role_type"], string> = {
  townsfolk: "Townsfolk",
  outsider: "Outsider",
  minion: "Minion",
  demon: "Demon",
};

/** `alignment`: the player's own, when it is not the character's (a Goon who changed sides). */
export function RoleCardView({
  role,
  alignment,
  compact = false,
}: {
  role: RoleCard;
  alignment?: Team | null;
  compact?: boolean;
}) {
  const tone = role.team === "good" ? "good" : "evil";
  const team = alignment ?? role.team;
  return (
    <div className={`card stack${compact ? " card-tight" : ""}`} style={{ textAlign: "left" }}>
      <div className="row-between">
        <span className="eyebrow">{TYPE_LABEL[role.role_type]}</span>
        <span className={`chip chip-${team}`}>{team === "good" ? "Good" : "Evil"}</span>
      </div>
      <div className={`row ${tone}`} style={{ gap: 12 }}>
        <RoleIcon roleId={role.id} width={compact ? 56 : 88} />
        <h2 style={{ fontSize: compact ? "1.4rem" : "2rem" }}>{role.name}</h2>
      </div>
      <p className={compact ? "small" : undefined}>{role.ability_text}</p>
      {role.ability_text.includes("*") && <p className="tiny faint">* Not the first night.</p>}
      {team !== role.team && (
        <p className={`small ${team}`}>
          You are now {team}: you win or lose with the {team} team.
        </p>
      )}
    </div>
  );
}
